<template>
  <v-btn depressed v-on="$listeners" v-bind="validAttrs">
    <v-icon class="mr-2" v-if="$attrs.icon" :color="color">
      {{ $attrs.icon }}
    </v-icon>
    <span class="text-none">
      <slot />
    </span>
  </v-btn>
</template>

<script>
  /* eslint-disable */
  export default {
    computed: {
      validAttrs() {
        const { color, icon, ...validAttrs } = this.$attrs
        return validAttrs
      },
      color() {
        return this.$attrs.color || 'secondary'
      }
    },
  }
</script>